import { Container, Flex, Heading, Loader, Paragraph, Stack } from "@eworkit/iris";
import React, { FC } from "react";
import { Link } from "react-router-dom";
import { useMedia } from "react-use";

import { MEDIA_SIZE_SM } from "@/core/media";

export type DashboardInfoStackProps = {
  number: number;
  label: string;
  route: string;
};

export const DashboardInfoStack: FC<DashboardInfoStackProps> = ({ number, label, route }) => {
  const isSmallScreen = useMedia(MEDIA_SIZE_SM);

  const isLoading = number === -1; // Might want to rework this

  return (
    <Flex justifyContent="center">
      <Container
        as={Link}
        to={route}
        sx={{ textDecoration: "none" }}
        style={{ display: "flex", flexDirection: "column" }}>
        {isLoading ? (
          <Flex flex={1} alignItems={"center"}>
            <Loader size={"lg"} />
          </Flex>
        ) : (
          <Stack gap={["xs", null, null, "sm"]}>
            <Heading size={["h-lg", null, null, "h-xl"]} align="center" color={number ? "n1000" : "n700"}>
              {number}
            </Heading>
            {isSmallScreen ? (
              <Paragraph size="p-sm" align="center" color="n700">
                {label}
              </Paragraph>
            ) : (
              <Heading size="h-xs" align="center" color="n700">
                {label}
              </Heading>
            )}
          </Stack>
        )}
      </Container>
    </Flex>
  );
};
